


































































































































































































































































































































































































































































import { IFilmCategory as ICat } from "@/@types/cinema/film-category";
import { IFilm, IFilmRatings } from "@/@types/cinema/films";
import { ILocale } from "@/@types/locale";
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import langConfig from "@/config/languags.config.json";

import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";
import StandartCategoryName from "@/components/app/card/standart-category-name.vue";
import StandartImage from "@/components/app/shared/image/standart-image.vue";
import NoImage from "@/components/app/shared/image/no-image.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: {
    StandartModal,
    btns: ChangeDeliteButtons,
    StandartCategoryName,
    StandartImage,
    NoImage,
  },
})
class FullMovieCard extends Vue {
  @Prop({ type: Array, default: () => [] }) categorys!: Array<ICat>;
  @Prop({ type: Object, default: null }) film!: IFilm;
  @Prop({ type: Boolean, default: false }) deleted!: boolean;

  @Inject() readonly bgFolder!: string;
  @Inject() readonly posterFolder!: string;
  @Inject() readonly logoFolder!: string;

  langsOpen = false;

  mounted(): void {
    this.$root.$on("bv::collapse::state", this.collapseStateHandler);
    this.$root.$on("bv::collapse::sync-state", this.collapseStateHandler);
  }

  beforeDestroy(): void {
    this.$root.$off("bv::collapse::state", this.collapseStateHandler);
    this.$root.$off("bv::collapse::sync-state", this.collapseStateHandler);
  }

  collapseStateHandler(id: string, state: boolean): void {
    if (id === "langs") this.langsOpen = state;
  }

  localeImage(obj?: {
    [x: string]: string;
  }): { img: string; lang: string } | null {
    if (!obj) return null;
    const keys = Object.keys(obj);
    if (!keys.length) return null;
    const prefs = [
      this.$i18n.locale,
      langConfig.preferred_language,
      "en",
      String(this.$i18n.fallbackLocale),
    ];
    for (const pref of prefs) {
      if (keys.includes(pref)) return { img: obj[pref], lang: pref };
    }
    return { img: obj[keys[0]], lang: keys[0] };
  }

  get bestImage(): { img: string; folder: string } | null {
    if (!this.film || !this.film.src) return null;
    if (this.film.src.bg) {
      return { img: this.film.src.bg, folder: `${this.bgFolder}/fullhd` };
    }
    const poster = this.localeImage(this.film.src.poster);
    if (poster) {
      return {
        img: poster.img,
        folder: `${this.posterFolder}/${poster.lang}/origin`,
      };
    }
    const vertical = this.localeImage(this.film.src.vertical_poster);
    return vertical
      ? {
          img: vertical.img,
          folder: `cinema/vertical_poster/${vertical.lang}/origin`,
        }
      : null;
  }

  get ratingKinopoisk(): string {
    return this.film && this.film.ratings && this.film.ratings.ratingKinopoisk
      ? String(this.film.ratings.ratingKinopoisk)
      : "—";
  }

  get ratingImdb(): string {
    return this.film && this.film.ratings && this.film.ratings.ratingImdb
      ? String(this.film.ratings.ratingImdb)
      : "—";
  }

  get directors(): Array<ILocale> {
    return (this.film && this.film.staff && this.film.staff.directors) || [];
  }

  get actors(): Array<ILocale> {
    return (this.film && this.film.staff && this.film.staff.actors) || [];
  }

  get hasStaff(): boolean {
    return this.directors.length > 0 || this.actors.length > 0;
  }

  get kinopoiskGenres(): Array<ILocale> {
    return (this.film && this.film.genres && this.film.genres.kinopoisk) || [];
  }

  get imDbGenres(): Array<ILocale> {
    return (this.film && this.film.genres && this.film.genres.imDb) || [];
  }

  get hasGenres(): boolean {
    return this.kinopoiskGenres.length > 0 || this.imDbGenres.length > 0;
  }

  get hasVideo(): boolean {
    const src = this.film && this.film.src;
    return !!src && !!(src.video || src.video_type || src.trailer);
  }

  get hasRatings(): boolean {
    const r = this.film && this.film.ratings;
    if (!r) return false;
    return [
      r.ratingKinopoisk,
      r.ratingImdb,
      r.metacritic,
      r.theMovieDb,
      r.rottenTomatoes,
      r.tV_com,
      r.filmAffinity,
    ].some((val) => (val ?? "") !== "");
  }

  get ratingRows(): Array<{ key: string; label: string; value: string }> {
    const r = (this.film && this.film.ratings) || ({} as IFilmRatings);
    const labels: Array<{ key: keyof IFilmRatings; label: string }> = [
      {
        key: "ratingKinopoisk",
        label: String(this.$t("Cinema.card.rentalRating.ratingKinopoisk")),
      },
      {
        key: "ratingImdb",
        label: String(this.$t("Cinema.card.rentalRating.ratingImdb")),
      },
      {
        key: "metacritic",
        label: String(this.$t("Cinema.card.rentalRating.metacritic")),
      },
      {
        key: "theMovieDb",
        label: String(this.$t("Cinema.card.rentalRating.theMovieDb")),
      },
      {
        key: "rottenTomatoes",
        label: String(this.$t("Cinema.card.rentalRating.rottenTomatoes")),
      },
      {
        key: "tV_com",
        label: String(this.$t("Cinema.card.rentalRating.tV_com")),
      },
      {
        key: "filmAffinity",
        label: String(this.$t("Cinema.card.rentalRating.filmAffinity")),
      },
    ];
    return labels
      .filter((item) => (r[item.key] ?? "") !== "")
      .map((item) => ({
        key: item.key,
        label: item.label,
        value: String(r[item.key]),
      }));
  }

  get srcBg(): { img: string; folder: string } | null {
    if (!this.film || !this.film.src || !this.film.src.bg) return null;
    return { img: this.film.src.bg, folder: `${this.bgFolder}/fullhd` };
  }

  get srcPosters(): Array<{ img: string; folder: string }> {
    if (!this.film || !this.film.src || !this.film.src.poster) return [];
    if (this.langsOpen) {
      return Object.keys(this.film.src.poster).map((lang) => ({
        img: this.film.src.poster[lang],
        folder: `${this.posterFolder}/${lang}/origin`,
      }));
    }
    const item = this.localeImage(this.film.src.poster);
    return item
      ? [{ img: item.img, folder: `${this.posterFolder}/${item.lang}/origin` }]
      : [];
  }

  get srcVerticalPosters(): Array<{ img: string; folder: string }> {
    if (!this.film || !this.film.src || !this.film.src.vertical_poster) {
      return [];
    }
    if (this.langsOpen) {
      return Object.keys(this.film.src.vertical_poster).map((lang) => ({
        img: this.film.src.vertical_poster[lang],
        folder: `cinema/vertical_poster/${lang}/origin`,
      }));
    }
    const item = this.localeImage(this.film.src.vertical_poster);
    return item
      ? [
          {
            img: item.img,
            folder: `cinema/vertical_poster/${item.lang}/origin`,
          },
        ]
      : [];
  }

  get srcLogos(): Array<{ img: string; folder: string }> {
    if (!this.film || !this.film.src || !this.film.src.logo) return [];
    if (this.langsOpen) {
      return Object.keys(this.film.src.logo).map((lang) => ({
        img: this.film.src.logo[lang],
        folder: `${this.logoFolder}/${lang}/origin`,
      }));
    }
    const item = this.localeImage(this.film.src.logo);
    return item
      ? [{ img: item.img, folder: `${this.logoFolder}/${item.lang}/origin` }]
      : [];
  }

  formatAgeLimit(val: string | null): string {
    if (!val) return "—";
    let clean = val.replace(/^age/i, "");
    if (/^\d+$/.test(clean)) clean += "+";
    return clean;
  }
}
export default FullMovieCard;
